import React, { Fragment } from 'react'
import { Tooltip, Progress } from 'antd'
import styled from '@emotion/styled'
import { EllipsisTooltip } from 'components'

const StyledState = styled.div(props => ({
	textTransform: "uppercase",
	fontSize: 11,
	width: '90%'
}))

const calculateProgress = (state, completedCount, pageCount) =>{
	let progress = 1;
	if(state){
		if(state === "Scanning") {
			progress = completedCount == 0 ? 0 : completedCount/pageCount;
		}
		if(state === "Pending" || state === "WebHook") {
			progress = 0;
		}
	}
	return progress * 100;
}

const ScanState =  ({ state, completedCount, pageCount, error }) => {
	let status;
	let colors;
	let stateShort;
	switch(state) {
		case "Pending":
			status = "active"
			colors={'0%': '#108ee9', '100%': '#108ee9'}
			stateShort = 'pending'
			break
		case "WebHook":
			status = "active"
			colors={'0%': '#108ee9', '100%': '#108ee9'}
			stateShort = 'in progress'
			break
		case "Scanning":
			status = "active"
			colors={'0%': '#108ee9', '100%': '#108ee9'}
			stateShort = 'in progress'
			break
		case "Complete":
			status = "success"
			colors={'0%': '#108ee9', '100%': '#87d068'}
			stateShort = 'complete'
			break;
		case "Stopped":
			status = "success"
			colors={'0%': '#108ee9', '100%': '#87d068'}
			stateShort = 'stopped'
			break;
		case "Complete With Post Error":
			status = "success"
			colors={'0%': '#108ee9', '100%': '#87d068'}
			stateShort = 'complete'
			break;
		case "Scan Complete":
			status = "success"
			colors={'0%': '#108ee9', '100%': '#87d068'}
			stateShort = 'complete'
			break;
		default:
			status = "exception"
			colors={'0%': '#b71c1c', '100%': '#e53935'}
			stateShort = 'error'
			break;
	}
	
	const ErrorMsgTooltipContainer = () => {
		return (
			<>
				<EllipsisTooltip style={{color: 'rgb(245, 100, 100)', fontWeight: 700 }}>Error: {error}</EllipsisTooltip>
			</>
		)
	}

	const TooltipError = () => {
		return(
			<Tooltip placement="right" title={<ErrorMsgTooltipContainer />}>
				<Progress
					percent={Math.floor(calculateProgress(state, completedCount, pageCount))}
					status={status}
					strokeWidth={10}
					strokeLinecap="square"
					showInfo={true}
					strokeColor={colors}
				/>
			</Tooltip>
		)
	}

	const TooltipState = () => {
		return(
			<Tooltip title={state}>
				<Progress
					percent={Math.floor(calculateProgress(state, completedCount, pageCount))}
					status={status}
					strokeWidth={10}
					strokeLinecap="square"
					showInfo={true}
					strokeColor={colors}
				/>
			</Tooltip>
		)
	}

	return (
		<Fragment>
			<StyledState>{stateShort}</StyledState>
			{
				error 
				? 
				<TooltipError />
				:
				<TooltipState />
			}
		</Fragment>
	)
}

export default ScanState
